import React, { useEffect, useState } from 'react';

//Material
import CloseIcon from '@mui/icons-material/Close';
import { Autocomplete, Box, Grid, Link, Modal, TextField, Typography } from '@mui/material';

import styled from '@emotion/styled';
import { Form, FormikProvider, useFormik } from 'formik';
import { useTranslate } from 'react-redux-multilingual';
import * as Yup from 'yup';
import './UserEditModal.css';
// import { useSnackbar } from 'notistack';
import { StyledLabel } from '../../components/StyledComponents';
// import ApiService from '../../helpers/apiHelper';
import { connect, useDispatch } from 'react-redux';
import { LetsGoBtn3 } from '../../components/Buttons';
import { setIsOpenUserEditModal, setUserData } from '../../redux/mainReducer';
// import { useSnackbar } from 'notistack';
// import {  encode as btoa, decode as atob } from 'base-64';
// import sha256 from 'crypto-js/sha256';
import ApiService from '../../helpers/apiHelper';
import { disableCyrillicRegExp, whiteSpaceRegExp } from '../../services/regularExp';
import InputMask from 'react-input-mask';
import { useSnackbar } from 'notistack';
import { UACities } from '../../services/UACIties';
import { useNavigate } from 'react-router-dom';
// import { UACities } from '../../services/UACIties';
// import { useNavigate } from 'react-router-dom';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '100%',
  maxWidth: { xs: 390, sm: 710, md: 810, xl: 870 },
  bgcolor: 'background.paper',
  borderRadius: '8px',
  border: 'none',
  boxShadow: 24,
  padding: { xs: '20px ', md: '50px 60px 50px 60px' },
  overflow: 'scroll',
  height: 'inherit',
  maxHeight: { xs: '100vh', sm: '95vh' },
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none'
  }
};

const CssTextField = styled(TextField)({
  '& label.Mui-focused': {
    color: '#000000'
  },
  '& label': {
    color: '#7C7C7C',
    opacity: 1,
    fontFamily: 'FixelText-Regular'
  },
  '& .MuiInputBase-root': {
    alignItems: 'end',
    backgroundColor: '#FFFFFF !important',
    boxShadow: '0px 0px 15px -5px rgba(0, 0, 0, 0.15)',
    borderRadius: '8px'
  },

  fontFamily: 'FixelText-Regular !important',
  margin: '5px 0px',

  '& ::placeholder': {
    color: '#7C7C7C',
    opacity: 1
  },

  '& .MuiInputBase-root.Mui-error': {
    backgroundColor: '#FFE5E5 !important'
  }
});

function UserEditModal({ isOpenModal, language, data }) {
  // const [imgs, setImgs] = useState([]);
  const [screenType, setScreenType] = useState('desktop');
  const [cities, setCities] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  useEffect(() => {
    if (window.screen.width <= 600) {
      setScreenType('mobile');
    }
  }, []);
  const translate = useTranslate();
  // const { enqueueSnackbar } = useSnackbar();

  const api = new ApiService('auth/user/update', translate);
  const schema = Yup.object().shape({
    nickname: Yup.string()
      .max(24, 'Максимально 24 символи')
      .min(2, 'Мінімально 2 символи')
      .required("Це поле обов'язкове")
      .matches(disableCyrillicRegExp, translate('error_regExp_nickname'))
      .test('Нікнейм не може включати пробіл', 'Нікнейм не може включати пробіл', (value) =>
        whiteSpaceRegExp.test(value)
      )
      .matches(whiteSpaceRegExp, translate('Нікнейм не може включати пробіл')),
    name: Yup.string()
      .max(30, 'Максимально 30 символів')
      .min(2, 'Мінімально 2 символи')
      .required("Це поле обов'язкове"),

    surname: Yup.string()
      .max(30, 'Максимально 30 символів')
      .min(2, 'Мінімально 2 символи')
      .required("Це поле обов'язкове"),
    city: Yup.string().max(50, 'Максимально 50 символів'),

    description: Yup.string().max(300, 'Максимально 300 символів')
    // number: Yup.string().min(13, 'Мінімально 13 символів' )
  });

  const formik = useFormik({
    initialValues: {
      name: data?.name ? data?.name : '',
      surname: data?.surname ? data?.surname : '',
      nickname: data?.nickname ? data?.nickname : '',
      country: data?.country ? data.country : 'Україна',
      region: data?.region ? UACities.find((region) => region.region === data.region) : '',
      city: data?.city ? data.city : '',
      number: data?.number ? data.number : '+380',
      description: data?.description ? data.description : ''
    },
    enableReinitialize: true,
    validationSchema: schema,

    onSubmit: (values, { resetForm, setErrors }) => {
      const newValues = { ...values };
      newValues.name = newValues.name[0].toUpperCase() + newValues.name.slice(1);
      newValues.surname = newValues.surname[0].toUpperCase() + newValues.surname.slice(1);
      newValues.region = newValues.region.region;

      api
        .updateData(newValues)
        .then(async (res) => {
          await dispatch(
            setUserData({
              ...data,
              ...newValues
            })
          );
          resetForm();
          dispatch(setIsOpenUserEditModal(false));
        })
        .catch((error) => enqueueSnackbar(error, { variant: 'error' }));
    }
  });

  const {
    errors,
    touched,
    values,
    handleSubmit,
    getFieldProps,
    submitForm,
    resetForm,
    setFieldValue
  } = formik;
  useEffect(() => {
    if (values.region !== '') setCities(values.region.cities);
  }, [values.region]);
  return (
    <div>
      <Modal
        open={isOpenModal}
        onClose={(event, reason) => {
          if (reason === 'backdropClick') {
            return;
          }
          dispatch(setIsOpenUserEditModal(false));

          resetForm();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="bonfair_userEdit_modal"
      >
        <Box sx={style} className="bonfair_userEdit_modal-box">
          <CloseIcon
            className="bonfair_userEdit_modal-close"
            style={{ position: 'absolute', right: '10px', top: '10px', cursor: 'pointer' }}
            onClick={() => {
              dispatch(setIsOpenUserEditModal(false));

              resetForm();
            }}
          />

          <FormikProvider value={formik}>
            <Form
              autoComplete="off"
              noValidate
              onSubmit={handleSubmit}
              style={{ display: 'flex', flexDirection: 'column', marginTop: '10px' }}
            >
              <Grid container spacing={screenType !== 'desktop' ? 1 : 2}>
                <Grid item xs={12} md={12} lg={12}>
                  <StyledLabel className="userEditModal-title-text">
                    {/* {translate('bonfair_service_modal')} */}
                    Редагування профілю
                  </StyledLabel>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={6}
                  sx={{ display: 'flex', flexDirection: 'column', height: '120px' }}
                >
                  <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                    Ім'я*
                  </Typography>
                  <CssTextField
                    placeholder="Ім'я*"
                    variant="outlined"
                    fullWidth
                    size="normal"
                    inputProps={{ style: { textAlign: 'left', textTransform: 'capitalize' } }}
                    error={Boolean(touched.name && errors.name)}
                    {...getFieldProps('name')}
                    value={values.name}
                  >
                    {values.name}
                  </CssTextField>
                  {touched.name && errors.name && (
                    <div
                      style={{
                        color: 'red',
                        margin: '5px 0px',
                        fontSize: '14px',
                        fontFamily: 'FixelText-Regular'
                      }}
                    >
                      {errors.name}
                    </div>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={6}
                  sx={{ display: 'flex', flexDirection: 'column', height: '120px' }}
                >
                  <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                    Прізвище*
                  </Typography>
                  <CssTextField
                    placeholder="Прізвище*"
                    variant="outlined"
                    fullWidth
                    size="normal"
                    inputProps={{ style: { textAlign: 'left', textTransform: 'capitalize' } }}
                    error={Boolean(touched.surname && errors.surname)}
                    {...getFieldProps('surname')}
                    value={values.surname}
                  >
                    {values.surname}
                  </CssTextField>
                  {touched.surname && errors.surname && (
                    <div
                      style={{
                        color: 'red',
                        margin: '5px 0px',
                        fontSize: '14px',
                        fontFamily: 'FixelText-Regular'
                      }}
                    >
                      {errors.surname}
                    </div>
                  )}
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={6}
                  sx={{ display: 'flex', flexDirection: 'column', height: '120px' }}
                >
                  <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                    Нікнейм*
                  </Typography>
                  <CssTextField
                    placeholder="Нікнейм*"
                    variant="outlined"
                    fullWidth
                    size="normal"
                    inputProps={{ style: { textAlign: 'left' } }}
                    error={Boolean(touched.nickname && errors.nickname)}
                    {...getFieldProps('nickname')}
                    value={values.nickname}
                  >
                    {values.nickname}
                  </CssTextField>
                  {touched.nickname && errors.nickname && (
                    <div
                      style={{
                        color: 'red',
                        margin: '5px 0px',
                        fontSize: '14px',
                        fontFamily: 'FixelText-Regular'
                      }}
                    >
                      {errors.nickname}
                    </div>
                  )}
                </Grid>

                {/*<Grid item xs={12} md={12} lg={12}>*/}
                {/*  <Typography*/}
                {/*    variant="subtitle2"*/}
                {/*    sx={{ fontSize: 16, fontFamily: 'FixelText-SemiBold' }}*/}
                {/*  >*/}
                {/*    Контактна інформація*/}
                {/*  </Typography>*/}
                {/*</Grid>*/}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={6}
                  sx={{ display: 'flex', flexDirection: 'column', height: '120px' }}
                >
                  <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                    Країна
                  </Typography>
                  <Autocomplete
                    disableClearable
                    disabled
                    options={['Україна']}
                    defaultValue={'Україна'}
                    value={values.country}
                    onChange={(event, value) =>
                      setFieldValue('country', value !== null ? value : '')
                    }
                    renderInput={(params) => (
                      <CssTextField {...params} placeholder="Країна" variant="outlined" />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={6}
                  sx={{ display: 'flex', flexDirection: 'column', height: '120px' }}
                >
                  <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                    Область
                  </Typography>
                  <Autocomplete
                    disableClearable
                    options={UACities}
                    // defaultValue={'Україна'}

                    value={values.region}
                    getOptionLabel={(option) => (option?.region ? option?.region : '')}
                    onChange={(event, value) => {
                      setCities(value.cities);
                      setFieldValue('region', value);
                      setFieldValue('city', '');
                    }}
                    // inputValue={values.region?.region ? values.region?.region : ''}
                    renderInput={(params) => (
                      <CssTextField {...params} placeholder="Область" variant="outlined" />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={6}
                  sx={{ display: 'flex', flexDirection: 'column', height: '120px' }}
                >
                  <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                    Населений пункт
                  </Typography>
                  <Autocomplete
                    disableClearable
                    disabled={cities.length === 0}
                    options={cities}
                    // defaultValue={'Україна'}

                    value={values.city}
                    onChange={(event, value) => setFieldValue('city', value)}
                    renderInput={(params) => (
                      <CssTextField {...params} placeholder="Населений пункт" variant="outlined" />
                    )}
                  />
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={6}
                  lg={6}
                  sx={{ display: 'flex', flexDirection: 'column', height: '120px' }}
                >
                  <Typography sx={{ fontFamily: 'FixelText-SemiBold', fontSize: 18 }}>
                    Телефон
                  </Typography>
                  <InputMask
                    alwaysShowMask
                    maskChar=""
                    mask="+380999999999"
                    value={values.number}
                    {...getFieldProps('number')}
                  >
                    {(inputProps) => (
                      <CssTextField
                        {...inputProps}
                        placeholder="Телефон"
                        variant="outlined"
                        fullWidth
                        size="normal"
                        inputProps={{ style: { textAlign: 'left' } }}
                        error={Boolean(touched.number && errors.number)}
                      >
                        {values.number}
                      </CssTextField>
                    )}
                  </InputMask>

                  {touched.number && errors.number && (
                    <div
                      style={{
                        color: 'red',
                        margin: '5px 0px',
                        fontSize: '14px',
                        fontFamily: 'FixelText-Regular'
                      }}
                    >
                      {errors.number}
                    </div>
                  )}
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <Link
                    onClick={(event) => {
                      event.preventDefault();
                      event.stopPropagation();
                      dispatch(setIsOpenUserEditModal(false));
                      navigate(`/${language}/account-settings`);
                    }}
                    variant="body2"
                    color="inherit"
                    sx={{ fontSize: 16, cursor: 'pointer', textUnderlineOffset: '3px' }}
                  >
                    До налаштувань приватності
                  </Link>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontSize: 16, fontFamily: 'FixelText-SemiBold' }}
                  >
                    Загальний опис
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <CssTextField
                    placeholder="Тут можна описати красним слівцем всі свої переваги. В розумних рамках, звичайно, до 300 символів. "
                    multiline
                    rows={6}
                    fullWidth
                    inputProps={{ style: { textAlign: 'left' } }}
                    error={Boolean(touched.description && errors.description)}
                    {...getFieldProps('description')}
                    value={values.description}
                  >
                    {values.description}
                  </CssTextField>
                  {values.description.length !== 0 && (
                    <p
                      style={{
                        margin: '0 5px',
                        color: 'gray',
                        textAlign: 'right',
                        fontSize: '14px'
                      }}
                    >{`${values.description.length}/300`}</p>
                  )}
                  {touched.description && errors.description && (
                    <div
                      style={{
                        color: 'red',
                        margin: '5px 0px',
                        fontSize: '14px',
                        fontFamily: 'FixelText-Regular'
                      }}
                    >
                      {errors.description}
                    </div>
                  )}
                </Grid>

                <Grid
                  item
                  xs={12}
                  style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
                >
                  <LetsGoBtn3
                    disabled={
                      values?.name.length < 2 ||
                      values?.surname.length < 2 ||
                      values?.nickname.length < 2
                    }
                    size="large"
                    onClick={() => {
                      submitForm();
                    }}
                    width={257}
                    style={{ textTransform: 'inherit' }}
                    text="Зберегти зміни"
                  />
                </Grid>
              </Grid>
            </Form>
          </FormikProvider>
        </Box>
      </Modal>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    language: state.Intl.locale,
    isOpenSearchBar: state.global.isOpenSearchBar
  };
};
export default connect(mapStateToProps)(UserEditModal);
